import { useI18nContext } from '@shared-snap/i18n/i18n-react'
import { getNavBarNOAuthLogo } from '@shared/brand'
import React from 'react'
import { ModalContainer, ModalOverlay } from '../../../components/styled-components/modal'
import { SMALL_DESKTOP_SCREEN_HEIGHT } from '../../../utils/constants'
import { renderRectangles } from '../../../utils/styles'
import { MagicLinkWrap, RectanglesWrap } from './style'

const MagicLink = ({ email }) => {
    const {
        LL: { login }
    } = useI18nContext()
    const brandLogo = getNavBarNOAuthLogo()
    const padding = window.innerHeight <= SMALL_DESKTOP_SCREEN_HEIGHT ? '25px' : '64px 37px 51.72px 37px'

    return (
        <ModalOverlay>
            <ModalContainer width={'512px'} height={'718px'} padding={padding}>
                <MagicLinkWrap>
                    <img src={brandLogo.img} style={brandLogo.style} />

                    <div className="text-container">
                        <div>
                            <h1>{login.sentMagicLink()}</h1>
                            <p>{login.sentMagicLinkDescr()}</p>
                            <span>{email}</span>
                        </div>
                    </div>

                    <RectanglesWrap>{renderRectangles(5)}</RectanglesWrap>
                </MagicLinkWrap>
            </ModalContainer>
        </ModalOverlay>
    )
}

export default MagicLink
